<template>
    <div>
        Patops versi {{ $store.getters.version }}
    </div>
</template>

<script>
export default {
    data () {
        return {
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/HomePage.vue